import { FC, useCallback } from "react";

import { IGuestlistTicketAndPassParams } from "Bands/types";
import { copy } from "shared/assets";
import { IStatus, ITheme } from "shared/types";
import { Table, TableColumn } from "shared/components";

const { actions: actionsCopy } = copy;
const ticketAndPassCopy = copy.guestlistBlock.ticketAndPasses.create;

interface TicketAndPassTableProps {
  ticketAndPasses: IGuestlistTicketAndPassParams[];
  handleEdit: (ticketAndPass: IGuestlistTicketAndPassParams) => void;
  handleDelete: (id: string) => void;
  hideActions?: boolean;
}

export const TicketAndPassTable: FC<TicketAndPassTableProps> = ({
  ticketAndPasses,
  handleEdit,
  handleDelete,
  hideActions,
}) => {
  const getRowActions = useCallback(
    (id: string) => {
      const findTicketAndPass = (
        id: string
      ): IGuestlistTicketAndPassParams | undefined => {
        return ticketAndPasses.find((ticketAndPass) => ticketAndPass.id === id);
      };
      return [
        {
          label: actionsCopy.edit,
          dataTestId: "edit",
          handleClick: () => {
            const ticketAndPass = findTicketAndPass(id);
            if (ticketAndPass) handleEdit(ticketAndPass);
          },
        },
        {
          label: actionsCopy.delete,
          dataTestId: "delete",
          handleClick: () => {
            handleDelete(id);
          },
          status: IStatus.error,
        },
      ];
    },
    [handleDelete, handleEdit, ticketAndPasses]
  );

  return (
    <Table
      data={ticketAndPasses}
      columns={getColumns()}
      theme={ITheme.secondary}
      getRowActions={hideActions ? undefined : getRowActions}
    />
  );
};

const getColumns = (): TableColumn[] => [
  {
    Header: ticketAndPassCopy.properties.ticketAndPassType.title,
    accessor: "label",
  },
  {
    Header: ticketAndPassCopy.properties.ticketsTotal,
    accessor: "ticketsTotal",
    Cell: ({ row }) => {
      const ticketAndPass = row.original as IGuestlistTicketAndPassParams;

      return ticketAndPass.isUnlimited
        ? "Unlimited"
        : ticketAndPass.ticketsTotal;
    },
  },
];
